// 1. 외부 패키지
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { useHistory } from "react-router-dom";

// 2. 프로젝트 내부 alias


// 3. 상대 경로
import media_atom from "../../atom/media-atom";
import get_basic_detail_selector from "../../selector/get-basic-detail-selector";
import { getQuery } from "../../shared/function";
import API from "../../service/api";
import AddressToCoordResponseModel from "../../service/kakao/model/address-to-coord-response-model";
import map_filter_atom from "../../atom/map-filter";
import search_atom from "../../atom/search-atom";
import { PATH } from "../../shared/constant";
import PcTop from "./pc-top";
import MobileTop from "./mobile-top";

// 4. 타입

const Top = () => {

	const media = useRecoilValue(media_atom);
	const history = useHistory()

	const data = useRecoilValue(get_basic_detail_selector(getQuery().idx));
	const { detail } = data;

	const [map_filter, setMapFilter] = useRecoilState(map_filter_atom);
	const setSearch = useSetRecoilState(search_atom);

	const onClickMapBtn = (e: React.MouseEvent<HTMLButtonElement>, address: string) => {
		e.preventDefault();
		API.kakao
			.addressToCoord(address)
			.then((res) => {
				addressToCoordSuccessCallback(res.data, address);
			})
			.catch(addressToCoordFailCallback);
	};

	function addressToCoordSuccessCallback(data: AddressToCoordResponseModel, address: string) {
		if(data.meta.total_count > 0) {
			let { x, y } = data.documents[0];
				setMapFilter({
					...map_filter,
					deal_kind: {
						...map_filter.deal_kind,
						tr: 'N',
						sub_division: 'Y',
					}
				});
			setSearch(address);
			history.push({
				pathname: `${PATH.MAP}`,
				hash: `LatLng=${y}^${x}`,
				state: 'address-from-detail-page'
			});
		} else {
			throw new Error();
		}
	}

	function addressToCoordFailCallback() {
		history.push(`/map?kZ=PY&IZ=0&_Z=N&fZ=N&vZ=3Y&GZ=Y&_Z=Y&LZ=Y&zZ=N&JZ=&X_kt=${detail.lat}&HzIt=6&wo_t=${detail.lng}&qyft=${detail.lat}&_cvt=${detail.lng}&FwGt=200&___t=0&DgLt=100&Xuzt=0&HsJt=999&djkt=0&ogIt=N&___t=Y&uPft=${detail.lat}&_svt=${detail.lng}&MRGt=200&_E_t=0&Q_Lt=Y&ilzt=Y&_YJt=Y&e_kt=Y&TEIt=Y&___t=Y`);
	}

	return (
		<div>
			{media === 'M' ? (
				<div className='top'>
					<div className='desc_address'>
						<span>{detail.address_text}</span>
						<button className='map_button' onClick={(e) => onClickMapBtn(e, detail.address_text)}>지도보기</button>
					</div>
					<div className='bunyang_title'>{detail.title}</div>
					<MobileTop />
				</div>
			) : (
				<>
					<div className='bunyang_title'>{detail.title}</div>
					<div className='top'>
						<div className='desc_address'>
							<span>{detail.address_text}</span>
							<button className='map_button' onClick={(e) => onClickMapBtn(e, detail.address_text)}>지도보기</button>
						</div>
						<PcTop />
					</div>
				</>
			)}
		</div>
	);
};

export default Top;